export default {
  automations: state => {
    return state.automations;
  },
  automationById: state => id => {
    const filtered = state.automations.filter(item => {
      return parseInt(item.id) === parseInt(id);
    });

    return typeof filtered[0] !== 'undefined' ? filtered[0] : null;
  },
  eventEvaluationTemplates: state => {
    return state.eventEvaluationTemplates;
  },
  conditionOperators: state => {
    return state.conditionOperators;
  },
  scheduleRepeatTemplates: state => {
    return state.scheduleRepeatTemplates;
  },
  scheduleRepeatTemplateById: state => id => {
    const filtered = state.scheduleRepeatTemplates.filter(item => {
      return parseInt(item.id) === parseInt(id);
    });

    return filtered.length > 0 ? filtered[0] : null;
  },
  automationsAvailableForRun: state => {
    return state.automations.filter(item => {
      const { definition } = item;
      const { actions } = definition;
      let found = false;
      actions.forEach(action => {
        const { runAutomation } = action;
        if (typeof runAutomation !== "undefined") {
          found = true;
        }
      });
      return !found;
    });
  }
};